import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

import { ExpandedRowProps } from "./types";
import ExpandedRowBody, {
  ListGroup,
  TextGroup,
} from "../../../../components/ExpandedRow";
import ButtonText from "../../../../components/ButtonText";
import Icon from "../../../../components/Icon";
import { IconName } from "../../../../components/Icon/types";
import { ACTION, SUBJECT } from "../../../../constants/permissions";
import Can from "../../../../components/Can";

export const ExpandedRow: FC<ExpandedRowProps> = ({
  description,
  skus,
  onMakeDefault,
  isDefault,
  code,
}) => {
  const { t } = useTranslation();
  const starIcon: IconName = "default-blue";

  return (
    <ExpandedRowBody>
      <ListGroup label="SKUs" list={skus} />
      <TextGroup label="Description" text={description} />
      <TextGroup label="ID" text={code} />
      {!isDefault ? (
        <Can I={ACTION.WRITE} a={SUBJECT.PRODUCT}>
          <ButtonText onClick={onMakeDefault}>
            <Icon>{starIcon}</Icon>
            {t("makeDefaultRecurlyOffering")}
          </ButtonText>
        </Can>
      ) : null}
    </ExpandedRowBody>
  );
};
